// extracted by css-extract-rspack-plugin
export default {"block":"Block-module__block--WnWDb","icon":"Block-module__icon--uIfnv","active":"Block-module__active--cqWk1"};